import { Api } from "queries/types";
import { useMutation, useQuery } from "react-query";
import { get, patch } from "./http";

export interface ShopFilters {
  brandId?: number | null;
  sectorManagerId?: number | null;
  "updatedAt[before]"?: string | null;
  "updatedAt[after]"?: string | null;
}

const useShopIndex = (filters?: ShopFilters) =>
  useQuery<Api.Shop[]>(["shops", filters], () => get("/shops", { params: filters }));

const useShopShow = (erpId: string, { enabled } = { enabled: true }) =>
  useQuery<Api.Shop, any>(["shops", erpId], () => get(`/shops/${erpId}`,{}), { cacheTime: 0, enabled: !!erpId});

const useShopUpdate = (erpId: string) => useMutation((shop: Partial<Api.Shop>) => patch(`/shops/${erpId}`, shop));

export { useShopShow, useShopUpdate, useShopIndex };
